import { ActionType, IAction } from '@src/types/action';

const filterReducer = (state: any, action: IAction) => {
  switch (action.type) {
    case ActionType.SET_QUERY_FILTERS:
      return {
        ...action.payload,
      };
    default:
      return {
        ...state,
        loading: false,
      };
  }
};

export default filterReducer;
